<template>
    <div v-if="pagamento && lista_zoop && lista_zoop.length">
        <table class="table table-hover table-sm">
            <thead>
                <tr>
                    <th>Zoop</th>
                    <th>Bandeira</th>
                    <th>Parcelas</th>
                    <th>Status</th>
                    <th>TID</th>
                    <th class="text-right">Valor</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in lista_zoop" :key="index" :class="cor_zoop(item)">
                    <td>{{ item.forma_pagamento.search }}</td>
                    <td>{{ item.bandeira_cartao ? item.bandeira_cartao.search : ''}}</td>
                    <td>{{ item.in_parcelas }}</td>
                    <td>{{ item.js_outros && item.js_outros.zoop ? ( item.js_outros.zoop.status ) : 'Aguardando...' }}</td>
                    <td>{{ item.js_outros && item.js_outros.zoop ? ( item.js_outros.zoop.transaction_id  ) : '...' }}</td>
                    <td class="text-right">{{ $util.formatMoeda(item.dc_valor) }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import _ from 'lodash';
import { subscribe, unSubscribe } from "../../../service/Notify.js";

export default {
    data() {
        return { 
            dados: null, 
            evento: "", 
         }
    },

    props: ['pagamento'], 

    computed: { 
        lista_zoop: function () { 
            return this.pagamento.item_pagamento_atendimentos.filter(ipa => 
                ipa.forma_pagamento && 
                !ipa.forma_pagamento.fl_nao_enviar_contself && 
                ipa.dc_valor > 0 && 
                ( ipa.id_forma_pagamento < 90 || ipa.id_forma_pagamento >= 100 ) 
            );
        }
    },

    methods: { 
        cor_zoop(ipa) { 
            if ( ipa.js_outros && ipa.js_outros.zoop && ipa.js_outros.zoop.status) { 
                if ( ipa.js_outros.zoop.status == "pagamento_confirmado" ) { 
                    return "table-success";
                } else { 
                    return "table-warning";
                }
            }

             return "";
        }
    },

    mounted() { 

        if ( this.pagamento ) { 

            this.evento = "zoop_pagamento_" + this.pagamento.id_pagamento_atendimento;

            console.log('subs', this.evento);

            subscribe(this.$store.state.dominio, this.evento, res => {

                if ( res.data && res.data.id_item_pagamento_atendimento && res.data.js_outros && res.data.js_outros.zoop ) { 
                    let index = _.findIndex(this.pagamento.item_pagamento_atendimentos, { id_item_pagamento_atendimento: res.data.id_item_pagamento_atendimento });
                    if ( index != -1 ) { 
                        this.pagamento.item_pagamento_atendimentos[index].js_outros = res.data.js_outros;
                    }
                }

                console.log("Evento recebido: " + this.evento, res);

            });

        }

    },

    beforeDestroy() { 
        if ( this.evento ) { 
            unSubscribe(this.$store.state.dominio, this.evento);
        }
    }
}
</script>
